module.exports = __webpack_public_path__ + "static/media/logo_wonderly_colored.2d1ec86e.png";